import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import { getQuestionnaireIntro, getQuestionnaireSection } from 'src/ui/features/Questionnaire/state/questionnaireActions';
import { QuestionnaireSectionPres } from '../presentational/QuestionnaireSectionPres';

class QuestionnaireSectionContainer extends Component {
  componentDidMount() {
    this.getIntroData();
  }
  getIntroData = () => {
    const { getQuestionnaireIntro, match } = this.props;
    return getQuestionnaireIntro(match.params, false, this.getSectionData);
  };
  getSectionData = () => {
    const { getQuestionnaireSection, match } = this.props;
    return getQuestionnaireSection(match.params);
  };
  render() {
    return <QuestionnaireSectionPres {...this.props} />;
  }
}

const mapStateToProps = state => ({
  gettingIntroData: state.questionnaire.gettingIntroData,
  introData: state.questionnaire.intro,
  gettingSectionData: state.questionnaire.gettingSectionData,
  sectionData: state.questionnaire.section,
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
});

const mapDispatchToProps = {
  getQuestionnaireIntro,
  getQuestionnaireSection,
  push,
  goBack,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireSectionContainer);
